<template>
  <v-container>
    <v-layout column>
      <h2 class="headline">You can create additional fields here</h2>
      <!--change formType to relevant-->
      <FormConstructor v-if="isWriteAvailable"/>
    </v-layout>
  </v-container>
</template>

<script>
  import FormConstructor from '@/components/shared/EvFormConstructor'
  import mixins from '@/utils/mixins'

  export default {
    name: 'FeaturedAttendeeFormConstructor',
    mixins: [mixins.isWriteAvailable],
    components: {
      FormConstructor
    },
    data () {
      return {
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/FeatureAttendee/FAFormConstructor.vue